"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FetchType;
(function (FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})(FetchType = exports.FetchType || (exports.FetchType = {}));
//# sourceMappingURL=types.js.map